import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Observable, map } from 'rxjs';
import { LocalizedDatePipe } from 'src/app/shared/localizedDatePipe';
import { EmployeeVisitDetails } from '../employee-visit-details';

@Component({
  selector: 'app-employee-visits-details',
  templateUrl: './employee-visits-details.component.html',
  styleUrls: ['./employee-visits-details.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule, LocalizedDatePipe, MatIconModule],
})
export class EmployeeVisitsDetailsComponent implements OnInit {
  @Input({ required: true }) employeeVisitsDetail$!: Observable<EmployeeVisitDetails[]>;
  totalHoursEmployeeVisits$: Observable<number> | undefined;

  ngOnInit(): void {
    this.totalHoursEmployeeVisits$ = this.employeeVisitsDetail$.pipe(
      map((visitsByDay) => {
        let totalVisits = 0;

        if (visitsByDay && visitsByDay.length > 0) {
          totalVisits = visitsByDay
            .map((ev) => ev.totalHours)
            .reduce((a, b) => {
              return a + b;
            });
        }

        return totalVisits;
      })
    );
  }
}
